import { TextContent } from '@cloudscape-design/components';
import { Link } from 'react-router-dom';
import { useTranslate } from '../i18n/useTranslate';
import { useWelcomeModal } from './providers/WelcomeModalProvider';
import FeedbackModal from 'src/components/FeedbackModal';
import { useState } from 'react';

const Footer = () => {
    const t = useTranslate();
    const { setWelcomeGruOpen } = useWelcomeModal();
    const currentYear = { currentYear: new Date().getFullYear() };

    return (
        <div style={styles.container}>
            <TextContent>
                {/* @ts-ignore */}
                <div style={styles.footerTextContainer}>
                    <div>
                        <strong>
                            {/* TODO: Update this URL when the actual tutorial broadcast video is available */}
                            <a
                                data-testid="footer-welcome"
                                style={styles.footerLink}
                                href="https://broadcast.amazon.com/videos/1278680/"
                                target="_blank"
                                rel="noopener"
                            >
                                {t('footer_gru_tutorial', 'GRU Tutorial')}
                            </a>
                        </strong>
                        <div style={styles.vr}></div>
                        <strong>
                            <a
                                style={styles.footerLink}
                                href="https://w.amazon.com/bin/view/Amazon_Robotics/BOS/LExT"
                                target="_blank"
                                rel="noopener"
                            >
                                {t('footer_about_team', 'About LExT')}
                            </a>
                        </strong>
                        <div style={styles.vr}></div>
                        <strong>
                            <a
                                style={styles.footerLink}
                                href="https://w.amazon.com/bin/view/Amazon_Robotics/BOS/LExT/GRU/"
                                target="_blank"
                                rel="noopener"
                            >
                                {t('gru_wiki', 'GRU Wiki')}
                            </a>
                        </strong>
                        <div style={styles.vr}></div>
                        <strong>
                            <a
                                style={styles.footerLink}
                                href="https://prod-na.archer.robotics.amazon.dev/"
                                target="_blank"
                                rel="noopener"
                            >
                                ARCHER
                            </a>
                        </strong>
                        <div style={styles.vr}></div>
                        <strong>
                            <a
                                href="https://amazon.enterprise.slack.com/archives/C07L7GWGPKN"
                                target="_blank"
                                rel="noopener"
                                style={{
                                    ...styles.footerLink,
                                    cursor: 'pointer',
                                }}
                            >
                                GRU Slack
                            </a>
                        </strong>
                        <div style={styles.vr}></div>
                        <strong>
                            <Link
                                to="/content-policy"
                                style={styles.footerLink}
                            >
                                {t('footer_content_policy', 'Content Policy')}
                            </Link>
                        </strong>
                    </div>
                    <div style={styles.text}>
                        <span>&copy; </span>
                        {t(
                            'footer_copyright',
                            `${currentYear.currentYear} Amazon GRU. All rights reserved.`,
                            currentYear
                        )}
                    </div>
                </div>
            </TextContent>
        </div>
    );
};

const styles = {
    container: {
        width: '100%',
        padding: '24px 0px',
        backgroundColor: '#0F1B2A',
    },
    text: {
        marginTop: '16px',
        color: 'white',
    },
    footerTextContainer: {
        textAlign: 'center',
    },
    footerLink: {
        display: 'inline-block',
        color: 'white',
        textDecoration: 'none',
    },
    vr: {
        display: 'inline-block',
        height: '12px',
        width: '1px',
        borderRight: '1px solid #414D5C',
        margin: '0 10px',
    },
};

export default Footer;
